import { useId, useState } from 'react';
import { createPortal } from 'react-dom';
import { NavLink } from 'react-router-dom';
import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/react';

export default function SidebarLink({ module, collapsed, onNavigate }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const { refs, floatingStyles, isPositioned } = useFloating({
    open, placement: 'right', strategy: 'fixed', whileElementsMounted: autoUpdate,
    middleware: [offset(12), flip(), shift({ padding: 12 })],
  });
  const showTooltip = collapsed && open;
  return <>
    <NavLink ref={refs.setReference} to={module.path} end={module.path === '/'}
      className={({ isActive }) => `navigation-link${isActive ? ' active' : ''}`}
      aria-label={module.title} aria-describedby={showTooltip ? id : undefined}
      onClick={() => { setOpen(false); onNavigate(); }}
      onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)} onBlur={() => setOpen(false)}
      onKeyDown={event => { if (event.key === 'Escape') setOpen(false); }}>
      <span className="navigation-icon material-symbols-rounded" aria-hidden="true">{module.icon}</span>
      <span className="navigation-label">{module.title}</span>
    </NavLink>
    {showTooltip && createPortal(<div ref={refs.setFloating} id={id} role="tooltip"
      className="navigation-tooltip" style={{ ...floatingStyles, visibility: isPositioned ? 'visible' : 'hidden' }}>{module.title}</div>, document.body)}
  </>;
}
